import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import Message from 'components/parts/message';
import { Table } from 'react-bootstrap';
import { IconButton } from 'styles/util';

/**
 *  [共通パーツ]詳細表示コンポーネント
 */
const ItemDetail = (props) => {
  const { title, labels, items, operation } = props;
  const style = (props.style === undefined) ? {width: 25, maxWidth: 210, minWidth: 210} : props.style;
  const renderDetail =  () => {
    return Object.keys(items).map((key, index) => {
      return (
        <tr key={index}>
          <td style={{...style}}>{labels[key]}</td>
          <td>{items[key]}</td>
        </tr>
      );
    });
  };
  return (
    <>
      <Message/>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th colSpan="2">
              <Div>
                <div>
                  {title}
                </div>
                <DivIcon>
                  {operation.edit && operation.edit.path &&
                    <Link to={operation.edit.path} style={{color: 'black'}}>
                      <i className="fa fa-edit" aria-hidden="true"></i>
                    </Link>}
                  {operation.reload &&
                    <IconButton onClick={operation.reload.reloadFunc} disabled={operation.reload.disabled}>
                      <i className="fa fa-refresh" aria-hidden="true"></i>
                    </IconButton>}
                </DivIcon>
              </Div>
            </th>
          </tr>
        </thead>
        <tbody>
          {renderDetail()}
        </tbody>
      </Table>
    </>
  );
};
ItemDetail.propTypes = {
  title: PropTypes.string,
  operation: PropTypes.object,
  labels: PropTypes.object,
  items: PropTypes.object,
  style: PropTypes.object,
};
ItemDetail.defaultProps = {
  title: '',
  operation: {},
  labels: {},
  items: {},
};
const Div = styled.div`
  display: flex;
`;
const DivIcon = styled.div`
  margin-left: auto;
`;
export default ItemDetail;
